import React, { useRef, useEffect } from 'react';
import { IconSvg } from '../IconSvg';
import './style.css';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

export const MobileMenu: React.FC<MobileMenuProps> = ({
  isOpen,
  onClose,
  title,
  children
}) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        onClose();
      }
    };

    // 使用 setTimeout 避免立即关闭菜单
    const timer = setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
    }, 100);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="mobile-menu-container">
      <div className="mobile-menu-overlay" onClick={onClose} />
      <div className="mobile-menu" ref={menuRef}>
        <div className="mobile-menu-header">
          <h3>{title}</h3>
          <button className="mobile-menu-close" onClick={onClose}>
            <IconSvg name="mdi:close" width={20} height={20} />
          </button>
        </div>
        <div className="mobile-menu-content">
          {children}
        </div>
      </div>
    </div>
  );
};